/* eslint-disable no-console */
import React from "react";
import Layout from "../../layouts/MocoLayout";

const Page = () => {
  return (
    <Layout>
      <iframe
        src="https://magis.blasemarang.web.id/"
        title="Pendidikan Madrasah"
        style={{
          width: "100%",
          height: "80vh",
          border: "none",
        }}
      />
    </Layout>
  );
};

export default Page;
